import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { TMSCustomer } from 'types/Load';
import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

type GetLTLCustomersSearchResponse = {
  customerList: TMSCustomer[];
  tmsTenant: string;
  message: string;
};

type GetLTLCustomersSearchOptions = {
  tmsIntegrationId?: number;
  pricingIntegrationId?: number;
  integrationName?: string;
};

export async function getLTLCustomersSearch(
  search: string,
  options: GetLTLCustomersSearchOptions = {}
): Promise<Result<GetLTLCustomersSearchResponse, ApiError>> {
  try {
    const params = new URLSearchParams({ name: search });

    if (options.tmsIntegrationId != null) {
      params.set('tmsIntegrationId', options.tmsIntegrationId.toString());
    }

    if (options.pricingIntegrationId != null) {
      params.set(
        'pricingIntegrationId',
        options.pricingIntegrationId.toString()
      );
    }

    if (options.integrationName) {
      params.set('integrationName', options.integrationName);
    }

    const response = await axios.get<GetLTLCustomersSearchResponse>(
      `/quote/ltl/customers/search?${params.toString()}`
    );
    return ok(response.data);
  } catch (error) {
    captureException(error, { functionName: 'getLTLCustomersSearch' });

    if (!isAxiosError(error)) {
      return err({ message: 'Failed to get list of LTL customers' });
    }

    return err({
      message:
        error.response?.data.message || 'Failed to get list of LTL customers',
    });
  }
}
